export default "__VITE_ASSET__b51f8272__"